export const hero = {
  title: 'Tjänstebils&shy;kalkylatorn',
  backgroundImage:
    'https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/contents/new-car/ev9/Kia_EV9_1920x1080px.jpg',
};

export const excerpt = [
  {
    heading:
      'Här kan du enkelt räkna ut vad det kostar att köra en laddbar tjänstebil från Kia.',
    paragraph:
      'Låg elförbrukning, lägre sociala avgifter och minskade koldioxidutsläpp - att köra en elbil eller laddhybrid som tjänstebil är ett smart val. I vår tjänstebilskalkylator kan du enkelt jämföra våra tjänstebilsmodeller och se vad det kommer att kosta att köra laddbart med Kia. I matrisen nedan kan du välja mellan 8 laddbara bilmodeller från Kia och två finansieringslösningar, Kia Finansiell leasing⁶⁾ och Kia Business Lease.⁵⁾',
  },
];

export const businessExcerpt = {
  heading: 'Kia Business Lease⁵⁾',
};

export const financialExcerpt = {
  heading: 'Kia Finansiell Leasing⁶⁾',
};

export const selectCar = {
  heading: 'Lägg till jämförelse',
  subHeading: 'Välj bil',
  subHeadingModel: 'Välj modell',
};

export const includedBusinessLeasing = [
  { label: 'Garanterat restvärde', value: 'Ja' },
  { label: 'Kia Serviceavtal¹⁵⁾', value: 'Ingår' },
  { label: 'Kia Bilförsäkring¹⁶⁾', value: 'Ingår' },
  { label: 'Kia Original Vinterhjul', value: 'Ingår' },
];

export const filter = {
  heading: 'Generella uppgifter',
  subHeading:
    'Reglera körsträcka och ändra globala värden som påverkar kostnaderna för alla bilar i jämförelsen.',
  typeOfLeasing: 'Typ av leasing',
  mileageLabel: 'Total körsträcka',
  mileageServiceLabel: 'Varav i tjänsten',
  elevatedFirstMonthRent: {
    label: 'Första förhöjd hyra',
    subLabel: '20% första förhöjd leasinghyra',
  },
  fuelBenefit: {
    label: 'Har du drivmedelsförmån?',
    subLabel: 'Välj om du har drivmedelsförmån från företaget',
  },
  fuelCost: 'Bränslekostnad bensin',
  fuelCostElectric: 'Elkostnad',
  marginalTax: 'Marginalskatt',
};

export const priceTable = {
  formansVardeNetto: 'Förmånsvärde bil netto/månad⁷⁾',
  totalUser: 'Totalkostnad för föraren/månad',
  totalCompany: 'Totalkostnad för företaget/månad',
  inclFuel: 'Inkl. drivmedel',
  formansVarde: 'Förmånsvärde bil⁷⁾',
  formansVardeFuel: 'Förmånsvärde bränsle',
  fuel: 'Drivmedel',
  finance: 'Finansiering',
  serviceDeal: 'Kia Serviceavtal¹⁵⁾',
  insurance: 'Försäkring¹⁶⁾',
  included: 'Ingår',
  carTax: 'Fordonskatt',
  fuelCost: 'Kostnad drivmedel',
  socialCost: 'Sociala avgifter',
  socialCostFuel: 'Sociala avgifter bränsle',
};

export const general = {
  changeModel: 'Byt modell',
  showDetails: 'Detaljerade värden',
  update: 'Uppdatera',
  close: 'Stäng',
};

export const carDetails = {
  title: 'Detaljerade värden för',
  price: 'Pris',
  usageTitle: 'Förbrukning',
  usageFuel: 'Bränsleförbrukning',
  usageElectric: 'Elförbrukning',
  totalElectic: 'Total körning på el',
  costFuel: 'Kostnad drivmedel',
};

export const legal = [
  'Kalkylen är framtagen i samarbete med Kia Finans och innebär ett estimat på totalkostnadskalkyl och är ej underlag för offert.<br><br> Vänligen se <a href="https://skatteverket.se/" target="_blank">https://skatteverket.se/</a> för aktuella värden samt beräkningar.',
];
